import './ribbongrid.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SpecialRibbon } from './../RibbonNew';
import Scrollable from './../Scrollable';
import ActivesSingleton from '../Header/ActivesSingleton';
import RibbonsUtil from '../../utils/RibbonsUtil';
import Utils from '../../utils/Utils';
import Ribbon from './../RibbonNew';
import { MUSIC_RIBBON_TYPE, NODE_RIBBONS, REMOVE_RIBBON, RIBBON_NAME } from './constants';
import Device from './../../devices/device';
import {
    VOID,
    FAVORITED_API,
    SEEN_API,
    RECORDINGS_API,
    LIVECHANNEL_API,
    RECORDINGS,
    MUNDIALSOCCERMATCHER,
    COMPLETED,
    SEEN_API_V1,
    FAVORITED_API_V1,
    LIVECHANNEL_API_V1,
} from '../RibbonNew/constants';
import RecordingProgressBar from './../RecordingProgressBar';
import {
    DELETE_CARD,
    UPDATE_CARD,
    UpdateCardFromRibbonUserObserver,
} from '../PersistentMiniEpg/MiniObserver';
import {
    showModal,
    MODAL_DELETE_TV_CHANNEL,
    HIDE_MODAL,
    MODAL_DELETE_LAST_SEEN,
    MODAL_DELETE_RECORDINGS,
    MODAL_DELETE_FAVORITE,
    MODAL_RECORD_SERIES_CONTENT,
} from '../../actions/modal';
import store from '../../store';
import * as api from '../../requests/loader';
import { setLastTouchLiveChannel, setLastTouchFavorited } from '../../reducers/user';
import LoadFav from '../../AAF/LoaderExp/LoadFav';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import SimpleGetRequestTask from '../../requests/tasks/SimpleGetRequestTask';
import RequestManager from '../../requests/RequestManager';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import { NPVR_RECORDABLE_EVENT_STATUS } from '../../AAF/Npvr/Constans';
import LayersControl from '../../utils/LayersControl';
import ChannelSingleton from '../Epg/ChannelsSingleton';
import GeneralRibbonUtils from '../RibbonNew/GeneralRibbonUtils';
import { decodeHTML5 } from '../../actions/metrics';
import { sendGAEvent } from '../../utils/analytics';
import channelStreamUtil from '../../utils/ChannelStreamUtil';
import Asset from '../../requests/apa/Asset';

class RibbonGrid extends Component {
    constructor(props) {
        super(props);
        this.focused = null;

        this.DOWN = 'DOWN';
        this.UP = 'UP';

        this.moveToSelector = null;

        this.state = {
            topPosition: 0,
            ribbonsPrev: this.props.ribbonsPrev != undefined ? this.props.ribbonsPrev : [],
            ribbonsRest: [],
            ribbonsCategories: this.props.ribbonsCategories,
            ribbonsTypeMenu: this.props.ribbonsTypeMenu,
        };
        this.ribbonsRecordings = null;
        if (this.props.ribbonsTypeMenu == 'music') {
            this.onFocusCardHandler = this.onFocusCardHandler.bind(this);
        }

        if (this.props.ribbonsTypeMenu == 'home') {
            this.handleFocus = this.handleFocus.bind(this);
            this.keyDownHandler = this.keyDownHandler.bind(this);
            this.handleDeleteFromRibbonLiveChannel =
                this.handleDeleteFromRibbonLiveChannel.bind(this);
            this.handleDeleteFromRibbonFavorite = this.handleDeleteFromRibbonFavorite.bind(this);
            this.handleDeleteFromRibbonRecordings =
                this.handleDeleteFromRibbonRecordings.bind(this);
        }
        this.getApiType = this.getApiType.bind(this);
        this.currentRibbonIdFocused = null;
        this.currentCardFocused = null;
        this.keys = Device.getDevice().getKeys();
        Utils.setMaxRibbonMarginTop(0);
        this.hasRecordings = false;
        this.isModalRecordSeriesContent = Utils.modalType() === MODAL_RECORD_SERIES_CONTENT;
    }

    componentDidMount() {
        this.addEventListeners();
        this.hasRecordings = this.props.code.includes('contenido');
        if (this.props.ribbonsTypeMenu == 'home') {
            setTimeout(() => {
                const modal = document.getElementsByClassName('modal-overlay');
                if (modal.length == 0) {
                    if (document.getElementsByClassName('ribbon-highlight').length == 0) {
                        window.SpatialNavigation.focus('.scroller-container .focusable.selected');
                    } else {
                        window.SpatialNavigation.focus('.scroller-container .focusable');
                    }
                }
            }, 300);
        }
    }

    cardOnFocus(event) {
        const { target: { firstChild, classList } = {} } = event || {};
        const { className = false } = firstChild || {};

        if (!classList.contains('link-zoom') && className && className.indexOf('card') !== -1) {
            setTimeout(() => {
                event.target.classList.add('link-zoom-week');
            }, 200);
        }
    }

    cardOnBlur(event) {
        const { target: { firstChild, classList } = {} } = event || {};
        const { className = false } = firstChild || {};

        if (!classList.contains('link-zoom') && className && className.indexOf('card') !== -1) {
            setTimeout(() => {
                event.target.classList.remove('link-zoom-week');
            }, 200);
        }
    }

    addEventListeners() {
        if (this.props.ribbonsTypeMenu == 'home') {
            this.removeEventListeners();
            document.addEventListener('keydown', this.keyDownHandler);
            document.addEventListener('sn:focused', this.cardOnFocus);
            document.addEventListener('sn:unfocused', this.cardOnBlur);
        }
    }

    removeEventListeners() {
        let element = document;
        if (this.isModalRecordSeriesContent) {
            const scrollerContainer = document.querySelector('.scrollabe-container-modal-series-content');
            if (scrollerContainer) element = scrollerContainer;
        }
        if (this.props.ribbonsTypeMenu == 'home') {
            element.removeEventListener('keydown', this.keyDownHandler);
            element.removeEventListener('sn:focused', this.cardOnFocus);
            element.removeEventListener('sn:unfocused', this.cardOnBlur);
        }
    }

    componentWillUnmount() {
        this.removeEventListeners();
    }

    getApiType(uriApi) {
        let response = '';
        if (!uriApi) {
            return response;
        }
        if (uriApi.includes(FAVORITED_API)) {
            response = FAVORITED_API;
        }
        if (uriApi.includes(FAVORITED_API_V1)) {
            response = FAVORITED_API_V1;
        }
        if (uriApi.includes(SEEN_API)) {
            response = SEEN_API;
        }
        if (uriApi.includes(SEEN_API_V1)) {
            response = SEEN_API_V1;
        }
        if (uriApi.includes(RECORDINGS_API)) {
            response = RECORDINGS_API;
        }
        if (uriApi.includes(LIVECHANNEL_API)) {
            response = LIVECHANNEL_API;
        }
        if (uriApi.includes(LIVECHANNEL_API_V1)) {
            response = LIVECHANNEL_API_V1;
        }
        return response;
    }

    keyDownHandler(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (LayersControl.isPlayerVisible()) {
            return;
        }
        console.log(
            '[KDOWN3] RibbonGrid> currentKey|ribbonId|data: ',
            currentKey,
            this.currentRibbonIdFocused,
            this.currentCardFocused
        );
        switch (currentKey) {
            case 'RED':
                e.preventDefault();
                e.stopPropagation();
                const navbar = store.getState().navbar;
                if (navbar && navbar.nodes && navbar.nodes.length > 0) {
                    const node = navbar.nodes.find((node) => node.code === this.props.code);
                    if (node && node.text && node.text !== '') {
                        sendGAEvent({
                            hitType: 'event',
                            eventCategory: NODE_RIBBONS.replace('{{NODE_NAME}}', node.text),
                            eventAction: REMOVE_RIBBON.replace(
                                '{{RIBBON_NAME}}',
                                this.props.ribbonsPrev.find(
                                    (ribbon) => ribbon.id === this.currentRibbonIdFocused
                                ).title
                            ),
                            eventLabel: this.currentCardFocused.title,
                        });
                    }
                }
                const apiType = this.getApiType(this.currentRibbonApi);
                switch (apiType) {
                    case LIVECHANNEL_API:
                    case LIVECHANNEL_API_V1:
                        this.handleDeleteFromRibbonLiveChannel(this.currentCardFocused, apiType);
                        break;
                    case RECORDINGS_API:
                        if (Utils.modalType() === MODAL_RECORD_SERIES_CONTENT) {
                            return;
                        }
                        this.handleDeleteFromRibbonRecordings(this.currentCardFocused, apiType);
                        break;
                    case SEEN_API:
                    case SEEN_API_V1:
                        this.handleDeleteFromRibbonLastSeen(this.currentCardFocused, apiType);
                        break;
                    case FAVORITED_API:
                    case FAVORITED_API_V1:
                        this.handleDeleteFromRibbonFavorite(this.currentCardFocused, apiType);
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }

    isFromModalListSerie = (data) => {
        return data && data.from && data.from === 'ModalRecordSeriesContent';
    };

    async deleteRecording(data) {
        const groupId = data.group_id;
        const eventId = data.event_id;
        const eventAlfId = data.event_alf_id;
        const actions = data.actions || {};
        const ribbonRecordings = this.props.ribbonsUser.filter(
            (ribbon) => ribbon.id === this.currentRibbonIdFocused
        );

        const getData = () => {
            this.moveToSelector = null;
            if (ribbonRecordings[0].items.length > 1) {
                this.moveToSelector = 'link-recordings';
            }
            UpdateCardFromRibbonUserObserver.fire({
                action: DELETE_CARD,
                cardGroupId: eventId,
                ribbonIds: [this.currentRibbonIdFocused],
                card: data,
            });
        };

        getData.bind(this);

        if (NpvrUtil.recordingIconEnable().enable) {
            if (NpvrUploader.isEventSerie(data)) {
                await NpvrUploader.updateStatusFromListSerie(
                    data.ext_series_id,
                    groupId,
                    NPVR_RECORDABLE_EVENT_STATUS,
                    true,
                    data.season_id
                );
                NpvrUploader.deleteByUrl(actions.delete, groupId).then(() => {
                    getData();
                });
            } else {
                NpvrUploader.deleteByUrl(actions.delete, groupId, eventId, eventAlfId).then(async () => {
                    if (this.isFromModalListSerie(data)) {
                        if (data && data.listSerieParams) {
                            const result = await new GeneralRibbonUtils.handleRecordingSeries(
                                data.listSerieParams
                            );
                            if (!result) {
                                // SE CIERRA MODAL Y SE ELIMINA LA GRABACION DEL DOM
                                store.dispatch(
                                    showModal({
                                        modalType: HIDE_MODAL,
                                        modalProps: {},
                                    })
                                );
                                if (
                                    data.listSerieParams.data &&
                                    data.listSerieParams.data.ext_series_id
                                ) {
                                    UpdateCardFromRibbonUserObserver.fire({
                                        action: DELETE_CARD,
                                        cardGroupId: data.listSerieParams.data.ext_series_id,
                                        ribbonIds: [this.currentRibbonIdFocused],
                                        card: data.listSerieParams.data,
                                    });
                                }
                            } else {
                                if (
                                    data.listSerieParams.data &&
                                    data.listSerieParams.data.ext_series_id
                                ) {
                                    UpdateCardFromRibbonUserObserver.fire({
                                        action: UPDATE_CARD,
                                        cardGroupId: data.listSerieParams.data.ext_series_id,
                                        ribbonIds: [this.currentRibbonIdFocused],
                                        card: { numEpisodesNew: result },
                                    });
                                }
                            }
                        }
                        return;
                    } else {
                        getData();
                    }
                });
            }
        } else {
            const deleteRecordingTask = new SimpleGetRequestTask(actions.delete, null);
            const result = await RequestManager.addRequest(deleteRecordingTask);
            getData();
            if (!result.response.success) {
            } else {
                const saved = DeviceStorage.getItem('recordings');
                const parsed = Utils.isJson(saved) ? JSON.parse(saved) : {};
                if (data && data.eventid_programme_id && parsed[data.eventid_programme_id]) {
                    delete parsed[data.eventid_programme_id];
                    DeviceStorage.setItem('recordings', JSON.stringify(parsed));
                }
            }
        }
    }

    async handleDeleteFromRibbonRecordings(data) {
        if (data && !data.cover) {
            const gidData = channelStreamUtil.get(data.group_id);
            if(gidData && gidData.cover) {
                data.cover = gidData.cover;
            } else {
                data.cover = Asset.get('asset_placeholder_landscape','/images/placeholder_landscape.png');
            }
        } else {
            data.cover = data.cover.replace('size=168x96', 'size=290x163');
        }
        const closeModal = () => {
            store.dispatch(
                showModal({
                    modalType: HIDE_MODAL,
                    modalProps: {},
                })
            );
        };

        const modal = {
            modalType: MODAL_DELETE_RECORDINGS,
            modalProps: {
                data,
                onSuccess: () => {
                    this.deleteRecording(data)
                        .then(() => {
                            if (this.isFromModalListSerie(data)) {
                                return;
                            }
                            closeModal();
                        })
                        .catch((err) => {
                            closeModal();
                        });
                },
                onCancel: () => {
                    closeModal();
                },
            },
        };
        store.dispatch(showModal(modal));
    }

    handleDeleteFromRibbonLastSeen(data) {
        const ribbonLastSeen = this.props.ribbonsUser.filter(
            (ribbon) => ribbon.id === this.currentRibbonIdFocused
        );
        if (ribbonLastSeen && ribbonLastSeen[0]) {
            const closeModal = () => {
                store.dispatch(
                    showModal({
                        modalType: HIDE_MODAL,
                        modalProps: {},
                    })
                );
            };

            const modal = {
                modalType: MODAL_DELETE_LAST_SEEN,
                modalProps: {
                    data,
                    onSuccess: () => {
                        api.removeLastSeen(data.group_id)
                            .then(() => {
                                UpdateCardFromRibbonUserObserver.fire({
                                    action: DELETE_CARD,
                                    cardGroupId: data.group_id,
                                    ribbonIds: [this.currentRibbonIdFocused],
                                });
                                closeModal();
                            })
                            .catch((err) => {
                                closeModal();
                            });
                    },
                    onCancel: () => {
                        closeModal();
                    },
                },
            };
            store.dispatch(showModal(modal));
        }
    }

    handleDeleteFromRibbonFavorite(data) {
        const ribbonFavorite = this.props.ribbonsUser.filter(
            (ribbon) => ribbon.id === this.currentRibbonIdFocused
        );
        if (ribbonFavorite && ribbonFavorite[0]) {
            const closeModal = () => {
                store.dispatch(
                    showModal({
                        modalType: HIDE_MODAL,
                        modalProps: {},
                    })
                );
            };

            const modal = {
                modalType: MODAL_DELETE_FAVORITE,
                modalProps: {
                    data,
                    onSuccess: () => {
                        const live = data.type === 'live';
                        api.deleteFavorite(data.group_id, live)
                            .then((response) => {
                                const responseData = response.data;
                                if (responseData && responseData.lasttouch && responseData.lasttouch.favorited) {
                                    store.dispatch(
                                        setLastTouchFavorited(responseData.lasttouch.favorited)
                                    );
                                }
                                UpdateCardFromRibbonUserObserver.fire({
                                    action: DELETE_CARD,
                                    cardGroupId: data.group_id,
                                    ribbonIds: [this.currentRibbonIdFocused],
                                });
                                LoadFav.deleteFav(data.group_id);
                                closeModal();
                            })
                            .catch((err) => {
                                closeModal();
                            });
                    },
                    onCancel: () => {
                        closeModal();
                    },
                },
            };
            store.dispatch(showModal(modal));
        }
    }

    handleDeleteFromRibbonLiveChannel(data) {
        const ribbonLiveChannel = this.props.ribbonsUser.filter(
            (ribbon) => ribbon.id === this.currentRibbonIdFocused
        );
        if (ribbonLiveChannel && ribbonLiveChannel[0]) {
            const closeModal = () => {
                store.dispatch(
                    showModal({
                        modalType: HIDE_MODAL,
                        modalProps: {},
                    })
                );
            };

            const modal = {
                modalType: MODAL_DELETE_TV_CHANNEL,
                modalProps: {
                    data,
                    onSuccess: () => {
                        // Llamar api

                        api.removeLiveChannel(data.group_id)
                            .then((resp) => {
                                const { lasttouch: { livechannel = null } = {} } = resp;
                                if (livechannel) {
                                    store.dispatch(setLastTouchLiveChannel(livechannel));
                                    this.moveToSelector = null;
                                    if (ribbonLiveChannel[0].items.length > 1) {
                                        this.moveToSelector = 'link-livechannel';
                                    }
                                    UpdateCardFromRibbonUserObserver.fire({
                                        action: DELETE_CARD,
                                        cardGroupId: data.group_id,
                                        ribbonIds: [this.currentRibbonIdFocused],
                                    });
                                }
                                // Llamar al last touch?
                                closeModal();
                            })
                            .catch((err) => {
                                closeModal();
                            });
                    },
                    onCancel: () => {
                        closeModal();
                    },
                },
            };
            store.dispatch(showModal(modal));
        }
    }

    shouldComponentUpdate(newProps, newState) {
        if (newProps.code && !newProps.code.includes('contenido')) {
            this.ribbonsRecordings = null;
        }
        if (this.props.ribbonsTypeMenu == 'home') {
            this.state.ribbonsPrev = newProps.ribbonsPrev;
            return (
                JSON.stringify(this.props) !== JSON.stringify(newProps) ||
                JSON.stringify(this.state) !== JSON.stringify(newState)
            );
        }
    }

    handleFocus(data, ribbonId) {
        if (this.props.ribbonsTypeMenu == 'home') {
            this.currentRibbonIdFocused = ribbonId;
            this.currentRibbonApi = data && data.api;
            this.currentCardFocused = data;
            this.focused = document.activeElement.dataset.snLeft;
            if (typeof this.props.focusHandler === 'function') {
                this.props.focusHandler(data);
            }

            if (
                Utils.getToggleFunctionsFromMetadata().scrolling_ribbon_home &&
                !this.props.code.includes('contenido') &&
                this.props.code !== 'series'
            ) {
                let item = document.getElementById(
                    document.activeElement.getAttribute('id')
                ).parentNode;
                while (item.getAttribute('class') != 'special-ribbon-carousel') {
                    item = item.parentNode;
                }
                let position = item.parentNode.offsetTop;

                if (!item.parentNode.classList.contains('bottom-ribbon')) {
                    let maxRibbonMarginTop = parseInt(Utils.getMaxRibbonMarginTop(), 10);
                    if (position > maxRibbonMarginTop) {
                        Utils.setMaxRibbonMarginTop(position);
                    }
                    document.querySelector(
                        '#slider-grid-movies .scroller-container'
                    ).style.marginTop = `-${position}px`;
                    item.parentNode.scrollIntoView();
                } else if (
                    item.parentNode.classList.contains('top-ribbon') ||
                    item.parentNode.classList.contains('middle-ribbon')
                ) {
                    document.querySelector(
                        '#slider-grid-movies .scroller-container'
                    ).style.marginTop = '0px';
                }
            }
        }
    }

    componentDidUpdate() {
        this.hasRecordings = this.props.code.includes('contenido');
        const isChannel = this.props.code === 'cfutbol';

        if (this.props.ribbonsTypeMenu == 'home') {
            let moveToSelector = this.moveToSelector;
            this.moveToSelector = null;

            const afterUpdate = () => {
                const modal = document.getElementsByClassName('modal-overlay');
                if (modal.length === 0) {
                    if (this.hasRecordings) {
                        if (moveToSelector) {
                            const ref = window.SpatialNavigation.focus(`.${moveToSelector}`);
                            moveToSelector = null;
                        } else {
                            window.SpatialNavigation.focus('.ribbon-classic .focusable');
                        }
                        this.resetParent();
                    } else if (isChannel) {
                            if (moveToSelector) {
                                const ref = window.SpatialNavigation.focus(`.${moveToSelector}`);
                                moveToSelector = null;
                            } else {
                                window.SpatialNavigation.focus('.ribbon-classic .focusable');
                            }
                            this.resetParent();
                    }  else {
                        if (document.getElementsByClassName('ribbon-highlight').length == 0) {
                            window.SpatialNavigation.focus(
                                '.scroller-container .focusable.selected'
                            );
                        } else {
                            if (moveToSelector) {
                                const ref = window.SpatialNavigation.focus(`.${moveToSelector}`);
                                moveToSelector = null;
                            } else {
                                window.SpatialNavigation.focus('.scroller-container .focusable');
                            }
                        }
                    }
                }
            };
            afterUpdate.bind(this);

            setTimeout(afterUpdate, 300);
        }
    }

    resetParent = () => {
        const scrollerContainer = document.querySelector('#slider-grid-movies .scroller-container');
        if (scrollerContainer && scrollerContainer.style && scrollerContainer.style.marginTop) {
            scrollerContainer.style.marginTop = '0px';
        }
    };

    getRibbonType(type) {
        let ribbonType = 'landscape';

        switch (type) {
            case 'Highlight':
                ribbonType = 'highlight';
                break;
            case 'square':
                ribbonType = 'square';
                break;
            case 'circle':
                ribbonType = 'circle';
                break;
            case 'category':
                ribbonType = 'category';
                break;
            default:
                ribbonType = 'landscape';
                break;
        }

        return ribbonType;
    }

    showRecordingCapacity() {
        return (
            this.ribbonsRecordings !== null && (
                <RecordingProgressBar ribbonRecordings={this.ribbonsRecordings} />
            )
        );
    }

    onFocusCardHandler(data, ribbonType) {
        if (this.props.ribbonsTypeMenu == 'music' && data && data.musicData) {
            // const cardId = `card-${data.music_class}-${data.musicData.id}`;
            const {
                id = false,
                musicData: { id: musicaDataId = 'default value' },
            } = data || {};
            const cardId = `card-${data.music_class}-${id || musicaDataId}`;
            const itemFocused = document.getElementById(cardId);

            let itemSelected = itemFocused;
            if (itemSelected) {
                do {
                    itemSelected = itemSelected.parentNode;
                } while (
                    itemSelected.classList != undefined &&
                    !itemSelected.classList.contains('ribbon-music')
                );

                const topPosition = itemSelected.offsetTop;
                const position = topPosition > 0 ? `-${topPosition}px` : '0px';
                const scrollerContainer = document.querySelector(
                    '#slider-grid-movies .scroller-container'
                );
                if (scrollerContainer != null)
                    scrollerContainer.style.marginTop = position != undefined ? position : '0px';
            }
            this.props.onFocusHandler(data);
        }
    }

    isString = (ribb) => typeof ribb === 'string';
    idStartsWithNumber = (stringId) => {
        if (this.isString(stringId)) {
            const id = stringId[0];
            return id >= 48 && id <= 57;
        } else return;
    };

    parserId = (id) => `a_${id}`;

    hasTsNPVR = () => {
        const userHasTs = ChannelSingleton.getMaxNpvrStorage();
        if (userHasTs > 0) return true;

        return false;
    };

    filterRecordings = (userRibbons) => {
        let idxRibbonRecording = [];

        if (!Array.isArray(userRibbons)) return { ribbons: userRibbons, idxRibbonRecording: [] };

        if (!this.hasTsNPVR()) {
            const nUserribbons = userRibbons.filter((ribbon, idx) => {
                if (ribbon.type === RECORDINGS) {
                    idxRibbonRecording.push(idx);
                }

                return ribbon.type !== RECORDINGS;
            });

            return { ribbons: nUserribbons, idxRibbonRecording };
        }

        return { ribbons: userRibbons, idxRibbonRecording };
    };

    filterRibbons = (ribbons, BlockedRibbonsIds) => {
        if (!Array.isArray(ribbons)) return ribbons;
        if (!Array.isArray(BlockedRibbonsIds)) return ribbons;
        if (BlockedRibbonsIds.length < 1) return ribbons;

        const filtered = [];

        ribbons.forEach((ribbon, idx) => {
            if (!BlockedRibbonsIds.includes(idx)) filtered.push(ribbon);
        });

        return filtered;
    };

    getLinks = () => {
        return Utils.getApaMetadataKey(
            'links_nav_configuration',
            Utils.mock_links_nav_configuration()
        );
    };

    render() {
        if (this.props.ribbonsTypeMenu == 'home') {
            const filteredUserRibbons = this.filterRecordings(this.props.ribbonsUser);
            const ribbonsUser = filteredUserRibbons.ribbons;
            const filteredRibbons = this.filterRibbons(
                this.props.ribbonsPrev,
                filteredUserRibbons.idxRibbonRecording
            );
            const ribbonsPrev = filteredRibbons != undefined ? filteredRibbons : undefined;
            const ribbonsRest = this.state.ribbonsRest;

            const ribbonsCategories = this.props.ribbonsCategories;
            const ribbonsInit = [...ribbonsPrev, ...ribbonsRest];
            
            if (ribbonsUser) {
                ribbonsUser.map((obj) => {
                    const ribbonObj = obj;
                    const ribbon = ribbonsInit.find((r) => r.id == ribbonObj.id);
                    const index = ribbonsInit.indexOf(ribbon);
                    if (ribbonObj.type === 'recordings' && this.props.code.includes('contenido')) {
                        this.ribbonsRecordings = ribbonObj;
                    }
                    ribbonsInit[index] = Object.assign({}, ribbon, ribbonObj);
                });
            }
            
            if (ribbonsCategories) {
                const [firstRibbon, secondRibbon, thirdRibbon] = ribbonsInit || [];
                const { type = '', id = false } = firstRibbon || {};
                const { id: secondRibbonId = false, items = [] } = secondRibbon || {};
                let index = 0;
                const deleteCount = 0;
                if (type === 'highlight') {
                    index = 1;
                    ribbonsCategories.items.map((item) => {
                        if (id) {
                            item.dataSnUp = `#${id} .focusable`;
                            const ribbonsShowDeleteButton = Utils.getRegionaliazedMetadata('ribbons_show_delete_button', '{default: {favorite: {enable: false}, lastSeen: {enable: false}}}');
                            const favoriteShowDeleteButton = (ribbonsShowDeleteButton.favorite &&  ribbonsShowDeleteButton.favorite.enable && ribbonsShowDeleteButton.favorite.type) || [];
                            const lastSeenShowDeleteButton = (ribbonsShowDeleteButton.lastseen &&  ribbonsShowDeleteButton.lastseen.enable && ribbonsShowDeleteButton.lastseen.type) || [];
                            const showDeleteButtonArray = [...favoriteShowDeleteButton, ...lastSeenShowDeleteButton]

                            if (showDeleteButtonArray.includes(secondRibbonId) && items.length === 0) {
                                item.dataSnDown = `#${thirdRibbon.id} .focusable`;
                            } else {
                                item.dataSnDown = `#${secondRibbonId} .focusable`;
                            }
                        }
                        return item;
                    });
                }

                ribbonsInit.splice(index, deleteCount, ribbonsCategories);
            }

            // Obtiene los ribbons con elementos
            const ribbonsWithItems = ribbonsInit.filter((ribbon) => {
                return Array.isArray(ribbon.items) && ribbon.items.length >= 1;
            });
            const {
                [ribbonsWithItems.length - 3]: lastButTwoWithItems,
                [ribbonsWithItems.length - 2]: lastButOneWithItems,
                [ribbonsWithItems.length - 1]: lastWithItems,
            } = ribbonsWithItems;

            // Valida el tipo de nodo para mostrar los ribbons con o sin elementos
            const links = this.getLinks();
            const targetNode = links.miscontenidos;
            let ribbons = [];

            if (window.location.pathname == `/node/${targetNode}`) {
                ribbons = ribbonsInit;
            } else {
                ribbons = ribbonsWithItems;
            }

            const node = new ActivesSingleton().getTvNode();
            const getClassRibbon = (index) => {
                if (ribbons.length <= 2) {
                    return 'middle-ribbon bottom-ribbon';
                } else {
                    return index < ribbons.length - 2 ? 'top-ribbon' : 'bottom-ribbon';
                }
            };
            let ribbonsWithoutItems = 0;
            const idexCarrusel = this.hasRecordings ? 1 : 3;
            const getLiveNextFootballGame = (ribbon) =>{
                return ribbon.items.filter(ribbon => (ribbon.status.scheduleStatus !== undefined && ribbon.status.scheduleStatus !== COMPLETED))
            }
            
            return (
                <div className="ribbongrid-wrapper">
                    <div
                        className="ribbongrid-container"
                        id={
                            Utils.getToggleFunctionsFromMetadata().scrolling_ribbon_home
                                ? 'slider-grid-movies'
                                : ''
                        }
                    >
                        <Scrollable
                            className={
                                this.ribbonsRecordings
                                    ? 'scrollabe-container-with-bar'
                                    : this.props.code.includes('contenido')
                                    ? 'scrollabe-container-without-bar-mis-contenidos'
                                    : this.props.code === 'series'
                                    ? 'scrollabe-container-modal-series-content' //* Caso para ModalRecordSeriesContent
                                    : this.props.code === 'cfutbol'
                                    ? 'scrollabe-container-without-bar-channels' //* Caso para Canales en vivo 1 elemento
                                    : 'scrollabe-container-without-bar'
                            }
                        >
                            {ribbons.map((ribbon, index) => {
                                //Mundial
                                if(ribbon.type === MUNDIALSOCCERMATCHER){
                                    ribbon.items = getLiveNextFootballGame(ribbon);
                                }
                                const { id } = ribbon;
                                const api = ribbon.url;
                                if (Array.isArray(ribbon.items) && ribbon.items.length < 1) {
                                    ribbonsWithoutItems++;
                                }
                                if (id == 'guia-tv') {
                                    if (ribbon && Array.isArray(ribbon.items)) {
                                        let props_asset = this.props.asset;
                                        ribbon.items.map((it, i) => {
                                            const url = encodeURIComponent(`/player/${it.id}/true`);
                                            const it_key = it.key;
                                            it.cover = props_asset.get(it_key);
                                            it.image_still = props_asset.get(it_key);
                                            it.src = `/node/${node}?url=${url}`;
                                            it.filterTV = i + '';
                                        });
                                    }
                                }

                                if (this.idStartsWithNumber(id)) {
                                    ribbon.id = this.parserId(id);
                                }

                                if (ribbon && ribbon.type && ribbon.type == MUSIC_RIBBON_TYPE) {
                                    if (
                                        this.props &&
                                        this.props.user &&
                                        this.props.user.isAnonymous
                                    ) {
                                        if (ribbon.items) {
                                            ribbon.items = [];
                                        }
                                    } else {
                                        if (ribbon.items) {
                                            const convertItem = Utils.mapRibbonToMusic(
                                                ribbon.items
                                            );
                                            const musicRb = new RibbonsUtil();
                                            ribbon.items = musicRb.transformMusicRibbonsElements(
                                                convertItem,
                                                'playlist',
                                                1
                                            );
                                            if (
                                                ribbon &&
                                                ribbon.items &&
                                                Array.isArray(ribbon.items)
                                            ) {
                                                ribbon.items.forEach((it) => {
                                                    if (it && typeof it === 'object') {
                                                        it.playListFromHome = true;
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }

                                if (Array.isArray(ribbon.items) && ribbon.items.length === 0) {
                                    ribbon.type = VOID;
                                }
                                let bottomRibbonClassName = getClassRibbon(index);

                                const landscape =
                                    lastButTwoWithItems &&
                                    lastButOneWithItems &&
                                    lastWithItems &&
                                    lastWithItems.type === 'landscape' &&
                                    lastButOneWithItems.type === 'landscape' &&
                                    lastButTwoWithItems.type === 'landscape';

                                if (index === ribbons.length - 1) {
                                    bottomRibbonClassName += landscape
                                        ? ' last-ribbon-landscape'
                                        : ' last-ribbon';
                                } else if (index === ribbons.length - 2) {
                                    bottomRibbonClassName += landscape
                                        ? ' last-but-one-ribbon-landscape'
                                        : ' last-but-one-ribbon';
                                } else if (index === ribbons.length - 3) {
                                    bottomRibbonClassName += landscape
                                        ? ' last-but-two-ribbon-landscape'
                                        : ' last-but-two-ribbon';
                                }
                                return (
                                    <SpecialRibbon
                                        index={index}
                                        bottomRibbon={bottomRibbonClassName}
                                        user={this.props.user}
                                        key={Math.random() * 10}
                                        {...ribbon}
                                        focusHandler={this.handleFocus}
                                        setMetricsEvent={this.props.setMetricsEvent}
                                        forceUpdateGrid={this.props.forceUpdateGrid}
                                        hasRecordings={this.hasRecordings}
                                        api={api}
                                        handleDeleteFromRibbonRecordings={
                                            this.handleDeleteFromRibbonRecordings
                                        }
                                        code={this.props.code}
                                    />
                                );
                            })}
                        </Scrollable>
                    </div>
                    {this.hasRecordings && this.showRecordingCapacity()}
                </div>
            );
        } else {
            const ribbonsCategories = this.props.ribbonsCategories;
            const ribbons = this.props.ribbons;
            
            if (ribbonsCategories) {
                const [firstRibbon, secondRibbon, ...rest] = ribbons || [];
                const { type = '', id = false } = firstRibbon || {};
                const { id: secondRibbonId = false, type: type2 = '' } = secondRibbon || {};
                let index = 0;
                const deleteCount = 0;

                if (type === 'carousel') {
                    index = 1;
                    ribbonsCategories.items.map((item) => {
                        if (id) {
                            item.dataSnUp = `#${id} .focusable`;
                            item.dataSnDown = `#${secondRibbonId} .focusable`;
                        }
                        return item;
                    });
                }

                ribbons.splice(index, deleteCount, ribbonsCategories);
            }

            return (
                <div
                    className="ribbongrid-wrapper"
                    id={
                        Utils.getToggleFunctionsFromMetadata().scrolling_ribbon_home
                            ? 'slider-grid-movies'
                            : ''
                    }
                >
                    <div className="ribbongrid-container" id="slider-grid-movies">
                        <Scrollable height={'410px'}>
                            {ribbons.map((ribbon, index) => {
                                const ribbonItems = ribbon.elements || ribbon.items;
                                const ribbonTitle = ribbon.ribbontitles
                                    ? ribbon.ribbontitles.medium
                                    : ribbon.items.title;
                                const typeRibbon = ribbon.type2 || ribbon.type;
                                const ribbonType = this.getRibbonType(typeRibbon);
                                const ribbonId = ribbon.ribbonIndex || ribbon.items;

                                return (
                                    <div key={index} className="ribbongrid-row ribbon-music">
                                        <Ribbon
                                            id={ribbonId}
                                            type={ribbonType}
                                            title={ribbonTitle}
                                            items={ribbonItems}
                                            focusable={true}
                                            focusHandler={this.onFocusCardHandler}
                                            visibleNumber={this.props.visibleNumber}
                                            setMetricsEvent={this.props.setMetricsEvent}
                                            carruselTitle={ribbonTitle}
                                            code={this.props.code}
                                        />
                                    </div>
                                );
                            })}
                        </Scrollable>
                    </div>
                </div>
            );
        }
    }
}

RibbonGrid.propTypes = {
    ribbonsPrev: PropTypes.array,
    user: PropTypes.shape({
        isLoggedIn: PropTypes.bool,
        isSusc: PropTypes.bool,
    }),
    focusHandler: PropTypes.func,
};

RibbonGrid.defaultProps = {
    user: {},
    ribbonsPrev: [],
    focusHandler: null,
};

export default RibbonGrid;



// WEBPACK FOOTER //
// ./src/components/RibbonGridNew/index.jsx